import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Use the page's own origin when served on a different domain (e.g. custom domain) so the session cookie stays first-party.
const API_ORIGIN = new URL(BACKEND_URL).host === window.location.host ? BACKEND_URL : window.location.origin;

const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    const path = window.location.pathname;
    if (err.response?.status === 401 && !url.startsWith("/auth/")) {
      if (path.startsWith("/admin")) window.location.href = "/admin-login?expired=1";
      else if (path.startsWith("/portal")) window.location.href = "/login?expired=1";
    }
    return Promise.reject(err);
  }
);

export default api;
export { BACKEND_URL };
